import {
    GET_CLOTHING_RECIPES_LOADING,
    GET_CLOTHING_RECIPES_SUCCESS,
    GET_CLOTHING_RECIPES_FAILURE
} from '../actionTypes'
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';
import { getRecursivelyAsync } from '../../utils/get-recursively-async';

export const getClothingRecipesSuccess = payload => ({
    type: GET_CLOTHING_RECIPES_SUCCESS,
    payload
})

export const getClothingRecipesFailure = () => ({
    type: GET_CLOTHING_RECIPES_FAILURE
})

export const getClothingRecipesAsync = payload => dispatch => {
    return dispatch(getRecursivelyAsync('clothing-recipes', getClothingRecipesSuccess, 0));
}